import { z } from "zod";

export const realEstateSchemaCreate = z.object({
  isJoint: z.boolean(),
  city: z.string(),
  country: z.string(),
  currency: z.string().nullish(),
  currentAssessedValueInCents: z.number(),
  lastAssessmentYear: z.number().int().min(1900),
  description: z.string().nullish(),
  equityInCents: z.number().nullish(),
  fairMarketValueInCents: z.number().nullish(),
  outstandingFirstMortgageInCents: z.number().nullish(),
  outstandingSecondMortgageInCents: z.number().nullish(),
  purchasePriceInCents: z.number(),
  purchaseYear: z.number().int().min(1900),
  state: z.string(),
  streetAddress: z.string(),
  titleHeldInNameOf: z.string(),
  zipcode: z.string(),
  userAPercentage: z.number().int().min(0).max(100).nullish(),
  userBPercentage: z.number().int().min(0).max(100).nullish(),
});

export const realEstateSchemaUpdate = realEstateSchemaCreate.partial();
